import { render, staticRenderFns } from "./ShokurekishoTextareaCard.vue?vue&type=template&id=959fde28"
import script from "./ShokurekishoTextareaCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoTextareaCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports